const packageVersion: string = require('../../package.json').version;

export const environment = {
  production: true,
  // package.json su collaudo e' gia' X.Y.Z-beta.N: aggiunge -beta solo se manca
  acuplaceVersion: packageVersion.includes('-beta') ? packageVersion : packageVersion + '-beta',
  googleProviderID: '256772122432-uu5s4vho584skt698gkgbftbees69gk8.apps.googleusercontent.com',
  trustedDomains: ['@acus.eu'],
  administrator: ['daniele.mameli'],
  apiUrl: "https://jarvis-collaudo.acus.eu/public-api/acuplace-api",
  socketEndpoint: "https://jarvis-collaudo.acus.eu/public-api",
  apiSupportEnpoint: "https://jarvis-collaudo.acus.eu/public-api/acuplace-support/create",
  jarvisApiUrl: "https://jarvis-collaudo.acus.eu/public-api/acuplace",
  // Account di test ammessi in collaudo: allineare con ACUPLACE_COLLAUDO_ALLOWED_EMAILS di Jarvis
  allowedEmails: ['daniele.mameli@acus.eu', 'andrea.rizzato@acus.eu', 'floriana.tenivella@acus.eu', 'giorgia.pagano@acus.eu'],
  productionRedirectUrl: 'https://acuplace.acus.eu/',
  enableQaHelper: true,
  enableFeedback: true,
  enableFeedbackAutoPopup: true,
  enableFeedbackOnDemand: true,
  enableFeedbackDashboard: true
};